<template>
  	<div v-if="areaEnabled" class="filter-container" @click="handleClose">
		<button-filter-dropdown @click="open" :disabled="isDisabled" :isExpanded="modalOpen">
			<template v-slot:buttonFilterContent>
				<span v-if="!selectedAreas.length">
					{{ areaHeader }}
				</span>
				<span v-else :class="{ 'has-multiple': selectedAreas.length > 1 }">
					<template v-for="(selected, index) in selectedAreas">
						{{ index < selectedAreas.length - 1 ? selected + "," : selected }}
					</template>
				</span>
			</template>
		</button-filter-dropdown>

		<modal-filter-dropdown :items="getActiveAreas" v-show="modalOpen">
			<template #modalFilterType="item">
				<div>
					<label>
						<input
						:checked="isChecked(item.props.Key)"
						@change="check($event)"
						type="checkbox"
						:value="item.props.Key"
						name="filterLocationCheckbox"
						/>
						<span>
						{{ item.props.Value }}
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 18 15"
							width="18"
							height="15"
							aria-hidden="true"
							focusable="false"
						>
							<path
							fill="#000"
							d="M16 0l1.43 1.4L4.98 14.13 0 9.037l1.43-1.398 3.55 3.63z"
							></path>
						</svg>
						</span>
					</label>
				</div>
			</template>
		</modal-filter-dropdown>
  	</div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
import merlinFilterDropdown from "../../shared/merlinFilterDropdown.vue";
import { mapState, mapGetters } from "vuex";
import EventBus from "../event-bus";
import buttonFilterDropdown from '../../shared/buttonFilterDropdown.vue'
import modalFilterDropdown from '../../shared/modalFilterDropdown.vue'

export default {
    components: {
        buttonFilterDropdown,
        modalFilterDropdown
    },
  extends: merlinFilterDropdown,
  methods: {
    check(e) {
      if (!e.target.checked) {
        this.$store.commit("areas/toggleAreaIds", e.target.value);
        this.$store.commit("areas/toggleCheckedArea", e.target.value);
        this.$store.dispatch("filterAttractions");
      } else {
        this.$store.commit("areas/toggleAreaIds", e.target.value);
        this.$store.commit("areas/toggleCheckedArea", e.target.value);
        this.$store.dispatch("filterAttractions");
      }
    },
    isChecked(key) {
      return this.areaIds.includes(key);
    }
  },

  computed: {
    ...mapState("areas", [
      "areaHeader",
      "areaIds",
      "areaEnabled",
      "activeAreas"
    ]),
    ...mapState("locations", ["locationsEnabled", "activeLocations"]),
    getActiveAreas() {
      return this.$store.getters.getActiveAreas;
    },

    isDisabled() {
      let areasLength = this.getActiveAreas.length;

      if (!this.activeLocations.length && this.locationsEnabled) {
        return true;
      } else if (!areasLength) {
        return true;
      }
    },
    selectedAreas() {
      return this.activeAreas
        .filter(area => {
          if (this.areaIds.includes(area.Key)) {
            return area.Value;
          }
        })
        .map(filtered => {
          return filtered.Value;
        });
    }
  }
};
</script>
